<app-section #parentSection
             [formGroup]="formGroup"
             [formConfig]="formConfig"
             [sectionRef]="section"
             [title]="title"
             class="contact-data-section"
             [ngClass]="{
                'contact-data-section--no-agreements': !agreementsVisible,
                'contact-data-section--no-phone-number': !phoneNumberVisible
             }"
             [containerClass]="true">

  <ng-template #section>

    <div class="email-phone-component" [ngClass]="{'col-preview-mode': previewMode}">
      <div class="col">
        <div *ngIf="canFieldDisplayed(consts.EMAIL)" class="section__component col-50">
          <app-text-field [errorsMap]="formFactoryService.errorsMap"
                          [control]="formGroup.controls[consts.EMAIL]"
                          [fieldConfig]="formFactoryService.fieldConfig(consts.EMAIL, formConfig)"
                          [context]="formConfig.formKey"
                          [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.EMAIL)]"
                          (markAsDirty)="markAsDirty($event)"
          >
          </app-text-field>
        </div>

        <!--<div class="col-50 email-phone-component__hint email-phone-component__hint&#45;&#45;email"-->
             <!--[innerHTML]="'CONTACT_SECTION.emailHint' | translate | safeHtml">-->
        <!--</div>-->

      </div>

      <div *ngIf="phoneNumberVisible" class="col email-phone-component__telephone-number-col">
        <div *ngIf="canFieldDisplayed(consts.PHONE_NUMBER)" class="section__component col-50 email-phone-component__telephone-number">
          <app-telephone-number-field [errorsMap]="formFactoryService.errorsMap"
                                      [control]="formGroup.controls[consts.PHONE_NUMBER]"
                                      [fieldConfig]="formFactoryService.fieldConfig(consts.PHONE_NUMBER, formConfig)"
                                      [context]="formConfig.formKey"
                                      [isDirtyBean]="isDirtyBean && isDirtyBean[getContextString(consts.PHONE_NUMBER)]"
                                      (markAsDirty)="markAsDirty($event)"
                                      class="email-phone-component__telephone-number-field"
          >
          </app-telephone-number-field>
        </div>

        <app-hint *ngIf="phoneNumberHintVisible"
                class="col-50 email-phone-component__hint"
                [arrowLeft]="isNext"
                [arrowUp]="true"
                [content]="'CONTACT_SECTION.phoneNumberHint'">
        </app-hint>
      </div>
    </div>

    <div *ngIf="agreementsVisible"
         class="agreements">
      <app-checkboxes-group #checkboxesGroup
                            [config]="checkboxesGroupConfig"
                            [fieldKeys]="checkboxesGroupFieldKeys"
                            [bean]="bean"
                            [formConfig]="formConfig"
                            [formGroup]="formGroup"
                            [formFactoryService]="formFactoryService"
                            (checkboxChange)="onFieldChange($event)"
      >
      </app-checkboxes-group>

        <div *ngIf="requiredFieldInfoVisible"
             class="agreements__required-field-info">
            {{ agreementsRequiredSymbol }} {{ 'SHARED.requiredField' | translate }}
        </div>

      <div *ngIf="readonlyAgreementsAllowed"
           class="agreements__readonly-agreements">
        <div *ngFor="let agreement of readonlyAgreements"
             class="agreements__readonly-agreement"
             [innerHTML]="getAgreementValue(agreement) | safeHtml"
        ></div>
      </div>
    </div>

  </ng-template>
</app-section>
